const isTrue = (val) => val === 'true' || val === true
// all env vars mapped to config
export const nxConfig = {
  // api
  PUBLIC_URL: process.env.NX_PUBLIC_PUBLIC_URL,
  // keycloak
  KEYCLOAK_URL: process.env.NX_PUBLIC_KEYCLOAK_URL,
  ADMIN_KEYCLOAK_URL: process.env.NX_PUBLIC_KEYCLOAK_URL_ADMIN,
  KEYCLOAK_REALM: process.env.NX_PUBLIC_KEYCLOAK_REALM,
  KEYCLOAK_REALM_ADMIN: process.env.NX_PUBLIC_KEYCLOAK_REALM_ADMIN,
  // keys
  RECAPTCHA_SITE_KEY: process.env.NX_PUBLIC_RECAPTCHA_SITE_KEY,
  GOOGLE_API_KEY: process.env.NX_PUBLIC_REACT_APP_GOOGLE_API_KEY,
  // timezone config
  timeZone: process.env.NX_PUBLIC_TIME_ZONE_DATE_STRING,
  // feature toggles
  adminAuthSelfManageEnabled: isTrue(process.env.NX_PUBLIC_ADMIN_AUTH_SELF_MANAGE),
  voteReceiptEnabled: isTrue(process.env.NX_PUBLIC_VOTE_RECEIPT_ENABLED),
  useNVAddress: isTrue(process.env.NX_PUBLIC_USE_NV_ADDRESS_LIST),
  // support email
  supportEmail: process.env.NX_PUBLIC_SUPPORT_EMAIL,
  // google config
  eligibleCountries: process.env.NX_PUBLIC_REACT_APP_ELIGIBLE_COUNTRIES || 'ca',
  useDatafix: isTrue(process.env.NX_PUBLIC_USE_DATAFIX),
}
export default nxConfig
